export enum IaqoboAirPermission {
    IQBA_FARETYPE_SHOW = 'iqba.fareType.show',
    IQBA_HOSTCODE_SHOW = 'iqba.hostCode.show',
    IQBA_BOOKING_PRICE_COST_SHOW = 'iqba.booking.price.cost.show',
    IQBA_BOOKING_PRICE_RETAIL_SHOW = 'iqba.booking.price.retail.show',
    SHARED_AIR_CARBON_FOOTPRINT_SHOW = 'shared.air.carbonFootprint.show',
    IQBA_QUOTE_RATING_YUCANGOO_VIEW = 'iqba.quote.rating.youcangoo.view',
    SHARED_AIR_CANCEL_AND_EXCHANGE_PENALTY_SHOW = 'shared.air.cancelAndExchangePenalty.show',
    IQBA_QUOTE_OFFER_ALTERNATIVES_USE = 'iqba.quote.offer.alternatives.use',
}
